import { type ReactNode, useState } from 'react';
import { FilterBar } from './FilterBar';
import { Sidebar } from './Sidebar';

export function AppShell({ children }: { children: ReactNode }) {
  // On <lg the sidebar is an off-canvas drawer; the FilterBar hamburger opens it.
  const [navOpen, setNavOpen] = useState(false);
  return (
    <div className="flex h-screen overflow-hidden bg-bg text-fg">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <FilterBar onMenu={() => setNavOpen(true)} />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto max-w-[1400px] p-4 sm:p-6">{children}</div>
        </main>
      </div>
    </div>
  );
}
